import React from 'react';
import { Box, Typography } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { BodyMassIndexAnswer as BMIAnswer } from '../../types/Answer';

interface Props {
  answer?: BMIAnswer;
}

const BodyMassIndexAnswer = ({ answer }: Props) => {
  const heightFt = answer?.bodyMassIndex?.heightFt;
  const heightIn = answer?.bodyMassIndex?.heightIn;
  const weightLb = answer?.bodyMassIndex?.weightLb;

  const calculateBMI = () => {
    if (!heightFt || !heightIn || !weightLb) return null;

    const ft = parseFloat(heightFt) || 0;
    const inches = parseFloat(heightIn) || 0;
    const lbs = parseFloat(weightLb) || 0;

    const heightInMeters = ft * 0.3048 + inches * 0.0254;
    const weightInKg = lbs * 0.453592;
    const bmi = weightInKg / Math.pow(heightInMeters, 2);

    return isNaN(bmi) || !isFinite(bmi) ? null : bmi.toFixed(1);
  };

  const bmi = calculateBMI();

  return (
    <div>
      <Typography color="textSecondary">Height</Typography>
      {heightFt && heightIn ? (
        <Typography>{`${heightFt}ft ${heightIn}in`}</Typography>
      ) : (
        <Typography>Not answered</Typography>
      )}

      <Typography color="textSecondary">Weight</Typography>
      {weightLb ? <Typography>{`${weightLb}lbs`}</Typography> : <Typography>Not answered</Typography>}

      <Typography color="textSecondary">BMI</Typography>
      {bmi ? <Typography>{bmi}</Typography> : <Typography>Not calculated</Typography>}

      <Box my={1}>
        <Divider />
      </Box>
    </div>
  );
};

export default BodyMassIndexAnswer;
